module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-933-min.679da5d7.jpg";